class Video {
  static onYouTubePlayerReady(event) {
    const callback = (trackingPercentage) => {
      if (trackingPercentage.indexOf('p') > -1) {
        const percentage = event.target.getCurrentTime() / event.target.getDuration() * 100;
        const title = event.target.videoTitle;
        const gaObj = { title, percentage };

        if (window && window._st && window._st.event) {
          window._st.event.publish('yt_videos', 'percentage_watched', gaObj);
        }
      }
    };

    event.target.tracking = new YtTracking(event.target, {
      trackings: [
        '0p', '5p', '10p', '15p', '20p', '25p', '30p', '35p', '40p', '45p', '50p',
        '55p', '60p', '65p', '70p', '75p', '80p', '85p', '90p', '95p', '100p',
      ],
      callback,
    });

    event.target.tracking.setupTrackList();
  }

  static onYouTubePlayerStateChange(event) {
    event.target.tracking.onVideoStateChange(event.data);

    const percentage = event.target.getCurrentTime() / event.target.getDuration() * 100;
    const title = event.target.videoTitle;
    const gaObj = { title, percentage };
    let state;

    switch (event.data) {
      case 0:
        state = 'end';
        break;

      case 1:
        state = 'play';
        break;

      case 2:
        state = 'paused';
        break;

      default:
        break;
    }

    if (!state) { return; }

    if (window && window._st && window._st.event) {
      window._st.event.publish('yt_videos', state, gaObj);
    }
  }

  constructor(element) {
    this.element = element;
    this.videoId = element.dataset.videoId;
    this.videoPlayer = null;
    this.cookieMessage = null;

    this.init();
  }

  init() {
    if (this.isRelay42Ready()) {
      this.element.addEventListener ('click', this.addVideoPlayer.bind(this));

      window._st.event.subscribe('cookiewall', 'SettingsAccept', this.checkCookie.bind(this));
      window._st.event.subscribe('cookiewall', 'PopupAccept', this.checkCookie.bind(this));

      this.checkCookie();
    } else {
      setTimeout(this.init.bind(this), 100);
    }
  }

  addVideoPlayer() {
    if (!this.videoPlayer && this.isCookieApproved()) {
      this.addIframe();
      this.addIframeApi();
    }
  }

  removeVideoPlayer() {
    if (this.videoPlayer) {
      this.videoPlayer.remove();
      this.videoPlayer = null;
    }
  }

  addCookieMessage() {
    if (!this.cookieMessage) {
      this.cookieMessage = document.createElement('div');
      this.cookieMessage.classList.add('video__cookieoverlay');

      const youtubeText = document.createElement('p');
      const cookieText = document.createElement('p');

      youtubeText.innerHTML = `Wilt u deze video bekijken? Dat kan. <a href="javascript:_stCookiePopup.showSettings()" data-change-cookie>Accepteer dan wel even de cookies.</a>`;
      cookieText.innerHTML = `<a href="https://www.youtube.com/watch?v=${this.videoId}" target="_blank" data-play-external>Of bekijk de video op Youtube</a>`;

      this.cookieMessage.appendChild(youtubeText);
      this.cookieMessage.appendChild(cookieText);

      this.cookieMessage.querySelector('[data-change-cookie]').addEventListener('click', (event) => {
        _st.event.publish('video/cookieoverlay', 'changeCookie', null);
      });

      this.cookieMessage.querySelector('[data-play-external]').addEventListener('click', (event) => {
        _st.event.publish('video/cookieoverlay', 'playExternal', null);
      });

      this.element.insertAdjacentElement('beforeend', this.cookieMessage);
      _st.event.publish('video/cookieoverlay', 'showOverlay', null);
    }
  }

  removeCookieMessage() {
    if (this.cookieMessage) {
      this.cookieMessage.remove();
      this.cookieMessage = null;
    }
  }

  checkCookie() {
    if (this.isCookieApproved()) {
      this.removeCookieMessage();
    } else {
      this.addCookieMessage();
      this.removeVideoPlayer();
    }
  }

  isCookieApproved() {
    if (typeof window._st === 'function') {
      const prefs = window._st.cookiepermission.getCookiePreferences();
      return prefs[3] || false;
    }

    return false;
  }

  isRelay42Ready() {
    return (typeof window._st === 'function') && window._st.event && window._st.cookiepermission;
  }

  addIframe() {
    this.videoPlayer = document.createElement('iframe');
    this.videoPlayer.src = 'https://www.youtube-nocookie.com/embed/' +
      this.videoId +
      '?autoplay=1&modestbranding=1&rel=0&enablejsapi=1&cc_load_policy=1';
    this.videoPlayer.id = this.videoId;
    this.videoPlayer.setAttribute('style', 'border: none;');
    this.videoPlayer.setAttribute('allowFullScreen', 'true');
    this.videoPlayer.setAttribute('allow', 'autoplay');

    this.element.insertAdjacentElement('beforeend', this.videoPlayer);
    this.isPlayerLoaded = true;
  }

  addIframeApi() {
    if (typeof YT !== 'undefined' && YT.loaded) {
      console.log('API is loaded');
      this.createYouTubePlayer();
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);

    window['onYouTubeIframeAPIReady'] = () => this.createYouTubePlayer();
  }

  createYouTubePlayer() {
    this.player = new YT.Player(this.videoId, {
      events: {
        'onReady': Video.onYouTubePlayerReady,
        'onStateChange': Video.onYouTubePlayerStateChange,
      },
    });
  }
}

class YtTracking {
  constructor(player, options) {
    if ((player === null) || (player === undefined)) {
      throw new Error('Missing player param!');
    }

    this.player = player;
    this.options = options;

    this.trackValues = this.options.trackings;
    this.callback = this.options.callback;
    this.trackList = [];
    this.videoTimer = null;
  }

  setupTrackList() {
    for (let i = 0, j = this.trackValues.length; i < j; i++) {
      this.trackList[this.trackValues[i]] = false;
    }
  }

  onVideoStateChange(state) {
    switch (state) {
      case YT?.PlayerState?.PLAYING:
        this.startVideoTimer();
        break;
      case YT?.PlayerState.ENDED:
        this.verifyVideoTime();
        this.stopVideoTimer();
        break;
      default:
        this.stopVideoTimer();
        break;
    }
  }

  startVideoTimer() {
    const _self = this;
    this.videoTimer = setInterval( () => {
      _self.verifyVideoTime();
    }, 1000);
  }

  stopVideoTimer() {
    clearInterval(this.videoTimer);
  }

  verifyVideoTime() {
    let currentValue;
    let percentage = 0;

    const totalTime = this.player.getDuration();
    const elapsedTime = Math.round( this.player.getCurrentTime() );

    for (let i = 0, j = this.trackValues.length; i < j; i++) {

      currentValue = this.trackValues[i].replace(/[a-z]/g, '');

      // tracking by percentage
      percentage = Math.round( ((100 * elapsedTime) / totalTime) );
      if ( (percentage >= currentValue) && (this.trackList[this.trackValues[i]] === false) ) {
        this.refreshTrackList(this.trackValues[i]);
      }
    }
  }

  refreshTrackList(track_value) {
    this.trackList[track_value] = true;
    this.publish(track_value);
  }

  publish(trackValue) {
    if ( (this.callback) && (typeof this.callback === 'function') ) {
      this.callback(trackValue);
    }
  }
}

document.querySelectorAll('[aa-video]').forEach((el) => new Video(el));
